export function getVatPercent(date) {   

    if (!date)
        date = new Date();

    if (date < new Date('2025-01-01')) return 17;
    return 18;
}


export function getVatPercentDecimal(date) {

    return getVatPercent(date) / 100;
}


/**
 * An order (הזמנה / הצעת מחיר) can be flagged "ללא מע"מ" (order.noVat) on its own, even on a
 * business that charges VAT. ProductList's vatPercentDecimal computed prop returns 0 for such an
 * order but never writes that 0 back, so order.vatPercentDecimal stays 0.18 on disk - meaning
 * nobody may derive an order's VAT from vatPercentDecimal (or from a business-wide rate) without
 * checking noVat first. This is the single source of truth for that rule.
 */
export function orderVatMultiplier(order, fallbackVatDecimal) {

    if (order && order.noVat)
        return 1;

    let decimal = order && typeof order.vatPercentDecimal === 'number'
        ? order.vatPercentDecimal
        : fallbackVatDecimal;

    return 1 + (typeof decimal === 'number' ? decimal : 0);
}


/**
 * The after-VAT total of a stored order. Reads order.totalSumAfterVat, except for ללא-מע"מ orders
 * whose stored value was persisted VAT-inflated (see orderVatMultiplier) - there the before-VAT sum
 * IS the total. Keeps every reader correct on rows written before that bug was fixed, without a
 * data migration.
 */
export function orderTotalAfterVat(order) {

    if (!order)
        return 0;

    let afterVat = Number(order.totalSumAfterVat);

    if (isNaN(afterVat))
        afterVat = 0;

    if (!order.noVat)
        return afterVat;

    let beforeVat = Number(order.totalSumBeforeVat);

    return isNaN(beforeVat) ? afterVat : beforeVat;
}



function asDate(date) {

    if (!date)
        return new Date();

    if (date instanceof Date)
        return isNaN(date.getTime()) ? new Date() : date;

    let d = new Date(date);

    return isNaN(d.getTime()) ? new Date() : d;
}


/**
 * The before-VAT shekels in one VAT-inclusive shekel at `date` (1 / 1.18 today, 1 / 1.17 before
 * 2025) - 1 for an עוסק פטור, whose prices carry no VAT. `date` is a Date or a YYYY-MM-DD string
 * (getVatPercent compares Dates - a string must be converted first, or it reads as "today").
 */
export function beforeVatFactor(date, osekPatur) {

    if (osekPatur)
        return 1;

    return 1 / (1 + getVatPercentDecimal(asDate(date)));
}


/** A VAT-inclusive amount without its VAT, to the agora. */
export function stripVat(amount, date, osekPatur) {

    let n = Number(amount);

    if (isNaN(n))
        return 0;

    return Math.round((n * beforeVatFactor(date, osekPatur) + Number.EPSILON) * 100) / 100;
}


/**
 * A cost the business typed (a catalog item's cost entry - purchase, fabric, sewing - or a
 * repair's materials / labor) as the item's profit counts it: BEFORE VAT, always (user,
 * 22/10/2026: the profit of the rentals is written without VAT everywhere, and every cost says
 * whether it is with or without VAT). `vatIncluded` is the entry's own checkbox ("כולל מע״מ"): the
 * amount was typed with the VAT in it, so the VAT comes off at the rate of `date`; unticked, the
 * typed amount IS the before-VAT cost. An עוסק פטור cannot deduct the VAT it paid, so for them the
 * typed amount is the cost whatever the box says.
 */
export function costBeforeVat(amount, vatIncluded, date, osekPatur) {

    let n = Number(amount);

    if (isNaN(n))
        return 0;

    if (!vatIncluded || osekPatur)
        return n;

    return stripVat(n, date, osekPatur);
}
